// Avoinna olevien ikkunoiden (Sheet) järjestys. Vain päällimmäinen ikkuna reagoi Esc-näppäimeen ja saa kohdistuksen,
// ja kaikki sen alla oleva (muut ikkunat, sovelluksen sisältö) poistetaan käytöstä (`inert`), ettei Tab-näppäin
// pääse taustan painikkeisiin eikä Esc sulje useampaa ikkunaa kerralla.

/** Pino ikkunatunnuksista. Palauttaa funktiot, joilla ikkuna kirjataan avoimeksi ja kysytään päällimmäinen. */
export function createSheetStack() {
  const items = [];
  return {
    /** Kirjaa ikkunan avoimeksi; palautettu funktio kirjaa sen suljetuksi. */
    push(id) {
      items.push(id);
      return () => {
        const i = items.lastIndexOf(id);
        if (i >= 0) items.splice(i, 1);
      };
    },
    isTop: (id) => items.length > 0 && items[items.length - 1] === id,
    top: () => (items.length ? items[items.length - 1] : null),
    size: () => items.length,
  };
}

/** Seuraava kohdistettava elementti Tab-kierrossa: kohdistus pysyy ikkunan sisällä. */
export function nextFocusIndex(count, current, backwards) {
  if (count <= 0) return -1;
  if (current < 0) return backwards ? count - 1 : 0;
  return backwards ? (current - 1 + count) % count : (current + 1) % count;
}

export const sheetStack = createSheetStack();
